export const FETCH_GAME_INVITATIONS_REQUEST       = 'game-invitations/fetch/request';
export const FETCH_GAME_INVITATIONS_SUCCESS       = 'game-invitations/fetch/success';
export const FETCH_GAME_INVITATIONS_FAIL          = 'game-invitations/fetch/fail';

